type BaseUrlParams = {
  required: Record<string, string | number>
  optional: Record<string, string | number | undefined>
}

export const serializeUrl = (basePath: string, params: BaseUrlParams): string => {
  const urlParams = new URLSearchParams()

  for (const [key, value] of Object.entries(params.required)) {
    urlParams.set(key, String(value))
  }

  for (const [key, value] of Object.entries(params.optional)) {
    if (value !== undefined) {
      urlParams.set(key, String(value))
    }
  }

  const query = urlParams.toString()
  return query ? `${basePath}?${query}` : basePath
}
